import { http } from "shared/api/http";
import { INotification } from "../models";

const buildNotificationsPath = (tenantId: string, organizationId: string) =>
  `${process.env.REACT_APP_API_BASE_URL}/api/v1/tenants/${tenantId}/organizations/${organizationId}/notifications`;

export const getNotifications = async (
  tenantId: string,
  organizationId: string,
  options?: { skip?: number; take?: number; unreadOnly?: boolean }
): Promise<INotification[]> => {
  const params = new URLSearchParams();
  if (options?.skip !== undefined) params.append("skip", options.skip.toString());
  if (options?.take !== undefined) params.append("take", options.take.toString());
  if (options?.unreadOnly) params.append("unreadOnly", "true");

  const queryString = params.toString();
  const url = `${buildNotificationsPath(tenantId, organizationId)}${
    queryString ? `?${queryString}` : ""
  }`;

  const res = await http.get<INotification[]>(url);
  return res?.data;
};

export const getUnreadCount = async (tenantId: string, organizationId: string): Promise<number> => {
  const res = await http.get<{ count: number }>(
    `${buildNotificationsPath(tenantId, organizationId)}/unread-count`
  );
  return res?.data?.count ?? 0;
};

export const markAsRead = async (tenantId: string, organizationId: string, id: string): Promise<INotification> => {
  const res = await http.patch<INotification>(
    `${buildNotificationsPath(tenantId, organizationId)}/${id}/read`
  );
  return res?.data;
};

export const markAllAsRead = async (tenantId: string, organizationId: string): Promise<void> => {
  await http.patch(`${buildNotificationsPath(tenantId, organizationId)}/read-all`);
};

export const notificationService = {
  getNotifications,
  getUnreadCount,
  markAsRead,
  markAllAsRead,
};
